export enum UserLevel {
  NATIONAL = 'National',
  STATE = 'State',
  DISTRICT = 'District',
  BLOCK = 'Block',
  FACILITY = 'Facility'
}
